import {SearchResult, Pageable, PageRequest} from "@core/model";
import {ApiBuilder} from "..";

const search = (builder: ApiBuilder) =>
  builder.query<
    Pageable<SearchResult>,
    PageRequest & {text: string; types?: string[]}
  >({
    query: params => ({
      url: `/api/search?text=${params.text}&page=${params.page}&size=${
        params.size
      }&sort=${params.sort}${
        params.types ? `&types=${params.types.join(",").toUpperCase()}` : ""
      }`,
      method: "GET",
    }),
  });

export {search};
